import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GdxLoadingPage } from './gdx-loading';

@NgModule({
  declarations: [
    GdxLoadingPage,
  ],
  imports: [
    IonicPageModule.forChild(GdxLoadingPage),
  ],
  exports: [
    GdxLoadingPage
  ]
})
export class GdxLoadingPageModule {}



// WEBPACK FOOTER //
// ./src/components/gdx-loading/gdx-loading.module.ts